module.exports = __webpack_public_path__ + "static/img/partner-hy.c777d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-hy.png
// module id = iWqp
// module chunks = 34